<template>
  <div :class="{'dark': isDarkMode}" class="min-h-screen flex flex-col">
    <AppHeader v-if="showNav" />
    <div class="flex flex-1 flex-col md:flex-row">
      <AppSidebar v-if="showSidebar" class="hidden md:block" />
      <main class="flex-1 p-4 bg-gray-50 dark:bg-gray-800 transition-all duration-300">
        <router-view />
      </main>
    </div>
    <AppFooter v-if="showNav" />
  </div>
</template>

<script>
import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import AppHeader from './components/common/AppHeader.vue'
import AppSidebar from './components/common/AppSidebar.vue'
import AppFooter from './components/common/AppFooter.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppSidebar,
    AppFooter
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    
    const showNav = computed(() => {
      // 在登录、注册页面和未登录时都不显示导航栏
      const authPages = ['login', 'register']
      const isAuthenticated = store.getters['user/isAuthenticated']
      return !authPages.includes(route.name) && isAuthenticated
    })
    
    const showSidebar = computed(() => {
      // 在登录、注册页面和未登录时都不显示侧边栏
      const authPages = ['login', 'register']
      const isAuthenticated = store.getters['user/isAuthenticated']
      return !authPages.includes(route.name) && isAuthenticated
    })
    
    const isDarkMode = computed(() => store.getters['user/isDarkMode'])
    
    onMounted(async () => {
      // 如果是登录页面，不执行自动登录
      if (route.name === 'login') {
        console.log("如果是登录页面，不执行自动登录")
        return
      }
      
      const authPages = ['login', 'register', 'help', 'privacy', 'terms']
      // 只在需要认证的页面时尝试自动登录
      if (!authPages.includes(route.name) && route.meta.requiresAuth) {
        try {
          await store.dispatch('user/fetchUser')
        } catch (error) {
          console.log('自动登录失败，跳转到登录页面')
          router.push('/login')
        }
      }
    })
    
    return {
      showNav,
      showSidebar,
      isDarkMode
    }
  }
}
</script>

<style>
@import 'tailwindcss/base';
@import 'tailwindcss/components';
@import 'tailwindcss/utilities';

/* 自定义全局样式 */
/* .btn-primary {
  @apply bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded-lg transition duration-200;
} */

/* 添加全局过渡效果 */
.page-enter-active,
.page-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style> 